<template>
    <div>
        <template v-if="error">
            <div class="error" v-if="error">
                <p>{{$t('error')}}</p>
                <button type="button" @click="loadFirstResources">
                    {{$t('retry')}}
                </button>
            </div>
        </template>

        <div v-show="!error" class="carousel-wrapper">
            <div class="carousel" ref="carousel">
                <template v-if="loading" >
                    <slot name="loading">
                        <div
                            v-for="numb in perPage"
                            :key="numb"
                            class="slide"
                        >
                            <slot name="placeholder" :element="{}">
                            </slot>
                        </div>
                    </slot>
                </template>

                <template v-else>
                    <div class="slider" :class="viewMode">
                        <div
                            class="slide-element"
                            
                            v-for="resourceElement in elements"
                            :key="resourceElement.id"
                            v-if="elements.length"
                        >
                            <slot 
                                :element="resourceElement" 
                                :changeViewMode="changeViewMode"
                            >
                                {{JSON.stringify(resourceElement)}}
                            </slot>
                          <hr/>
                        </div>

                        <p v-if="elements.length === 0">{{$t('noRecords')}}</p>
                        <div v-if="loadingMore" class="slide slide-slide">
                            <Spinner v-if="loadingMore"/>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import Spinner from '../Spinner';
import EventBus from '../../eventbus';
import _ from 'lodash'
import VideoWatchBox from "../Post/Movie/Container.vue";

import resources from '../../resources';

import { UserVideoConfig } from '../../modules/video/UserVideoConfig';

export default {
    components: {
        Spinner,
        VideoWatchBox
    },
    props: {
        resource: {
            type: Object,
            required: true,
        },
        params: {
            type: Object,
            required: false,
            default: () => ({})
        },
        defaultParams: {
            type: Object,
            required: false,
            default: () => ({})
        },
        perPage: {
            required: false,
            default: 4
        },
        showIfEmpty: {
            type: Boolean,
            required: false,
            default: true,
        },
        viewMode: {
            type: String,
            required: false,
            default: 'vertical',
        },
    },
    data(){
        return {
            elements: [],
            loading: true,
            loadingMore: false,
            error: false,
            lastLoadedPage: null,
            paginationParams: {
                page: 1,
                per_page: this.perPage,
            },
            paginationMeta: {
                total: null,
                total_pages: null,
                count: null,
            },
            scrollData: {
                left: 0,
                right: 0,
                rightLimit: 0,
                leftLimit: 0,
                width: 0,
            },
            slideMovementTimeout: null,
            isEmpty: false,
            moviesWaiting: [],
            moviesPlayer: {},
            moviePlayingRef: null,
            currentFetchId: null,
        };
    },
    methods: {
        // proper implementation - do not use arrow function // debounce o throttle
        endOfScrollPageReached:_.throttle(function(){
            // console.log('BIP');
            this.loadMoreResources();
        }, 500),
        
        loadFirstResources(){
            //this.$emit('elementsCount', 0);

            this.elements = [];
            this.loading = true;
            this.loadingMore = false;
            this.error = false;
            this.lastLoadedPage = null;
            this.paginationParams = {
                page: 1,
                per_page: this.perPage,
            };

            this.paginationMeta = {
                total: null,
                total_pages: null,
                count: null,
            };

            this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
        },
        loadMoreResources(){
            this.loadingMore = true;
            this.addResources(Object.assign({}, this.defaultParams, this.params, this.paginationParams));
        },
        addResources(params){
            const fetchId = Math.random();
            this.currentFetchId = fetchId;

            this.resource.index(params)
                .then((response) => {
                    if (this.currentFetchId !== fetchId) return;

                    this.loading = false;
                    this.loadingMore = false;

                    const data = response.data.data;
                    for (let i = 0; i < data.length; i++) {
                        
                        // Verifico si el elemento ya existe en el array
                        let isInArray = false;
                        for (let j = 0; j < this.elements.length; j++) {
                            if (data[i].post_id === this.elements[j].id) {
                                isInArray = true;
                                break;
                            }
                        }
                        if (isInArray) continue;
                        if (data[i].content.length === 0) continue;

                        // Agrego el elemento al array
                        this.elements.push(data[i]);
                    }

                    this.paginationMeta = response.data.meta.pagination;
                    this.lastLoadedPage = params.page;
                }).catch(() => {
                    this.loading = false;
                    this.error = true;
                });
        },
        loadMoreForInfiniteScroll() {
            let currentPosition = document.documentElement.scrollTop + window.innerHeight;
            let tara            = (this.perPage * .75) * (window.innerHeight*.9)
            let positionToReach = document.documentElement.offsetHeight - tara;
            let bottomOfWindow  = currentPosition > positionToReach;
            if (bottomOfWindow && !this.loading && !this.loadingMore && this.paginationMeta.current_page < this.paginationMeta.total_pages) {
                this.endOfScrollPageReached();
            }
        },
        isMovie(element) {
            return element.component === "movie";
        },
        videoHardAppendHandler(elem, handler) {
            const refName = elem.id;
            if (!this.moviesWaiting.includes(refName)) 
                this.moviesWaiting.push(refName);

            this.moviesPlayer[refName] = { handler };

            if (this.moviePlayingRef) 
                this.moviesPlayer[this.moviePlayingRef].handler("pause");

            this.moviePlayingRef = refName;
            handler("play");
            handler("mute", UserVideoConfig.muted);
        },
        videoAppendHandler(elem, handler) {
            const refName = elem.id;
            if (!this.moviesWaiting.includes(refName)) {
                this.moviesWaiting.push(refName);
                this.moviesPlayer[refName] = { handler };
            }

            if (!this.moviePlayingRef) this.videoPlayNext();
        },
        videoRemoveHandler(elem) {
            const refName = elem.id;
            this.moviesWaiting = this.moviesWaiting.filter(waitRef => {
                const condition = refName !== waitRef;

                if (!condition) delete this.moviesPlayer[refName];

                return condition;
            });

            if (refName === this.moviePlayingRef) this.videoPlayNext();
        },
        videoPlayNext() {
            this.moviePlayingRef = this.moviesWaiting[0];
            if (this.moviePlayingRef) {
                const handler = this.moviesPlayer[this.moviePlayingRef].handler;
                handler("mute", UserVideoConfig.muted);
                handler("play");
            }
        },
        videoMuteHandler() {
            if (!this.moviePlayingRef) return;

            UserVideoConfig.toggleMuted();
            const handler = this.moviesPlayer[this.moviePlayingRef].handler;
            handler("mute", UserVideoConfig.muted);
        },
        changeViewMode(id) {
            this.$emit('changeViewMode', id);
        },
    },
    watch: {
        'paginationParams.defaultParams': function(value){
            this.loadFirstResources();
        },
        'paginationParams.params': function(value){
            this.loadFirstResources();
        },
        'perPage': function(value){
            this.paginationParams.per_page = value;
        },
        'lastLoadedPage': function(value){
            if(value === null){
                this.paginationParams.page = 1;
            }else{
                this.paginationParams.page = value + 1;
            }
        },
        elements: {
            handler(){
                this.$emit('elementsCount', this.elements.length);
            },
            deep: true,
        },
        loading: function(value){
            EventBus.$emit('loadingResource', value);
        },
        '$store.state.general.site_type': function(value) {
            this.currentFetchId = null;
            this.loadFirstResources();
        }
    },
    mounted(){
        this.loadFirstResources();
        window.addEventListener('scroll', this.loadMoreForInfiniteScroll);
        EventBus.$on('languageChanged', () => {
            this.loadFirstResources();
        });

        EventBus.$on('unlockedPostWithTokens', (model, post) => {
            resources.models.getPost({ postID: post.post_id, modelID: model.id })
            .then((response) => {
                let data = response.data.data;

                this.elements = this.elements.map((item) => {
                    if (item.post_id==post.post_id) return data;
                    return item;
                })
                        
            }).catch((err) => {
              this.unlocked = false;
            });
        });

        this.$on('videoRemove', this.videoRemoveHandler);
    },
    computed: {
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadMoreForInfiniteScroll);
    }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.slider {
    max-width: 100%;

    &.vertical {

        .slide-element {
            width: 600px;
            max-width: 90%;
            min-height: 300px;
            margin: 5px auto;
            @media(max-width: 720px){
                max-width: 100%;
            }
            
            hr{
                border-color: #dcdcdc;
            }
        }
    }

    &.grid {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-around;

        .slide-element {
            width: 33.333333%;
            outline: 1px solid #dcdcdc;
            display: flex;
            aspect-ratio: 1;

            hr {
                display: none;
            }
        }

        .slide-slide {
            display: flex;
            width: unset !important;
            min-width: 33%;
            max-width: 66%;
            flex-grow: 1 !important;

            .loader {
                margin: auto;
            }
        }
    }
}

.carousel-wrapper{
    position: relative;

    @media(min-width: 770px) and (max-width: 1440px){

    }

    &:focus{
        .arrow{
            .draw{
                opacity: 1;
            }
        }
    }

    .carousel{
        scroll-behavior: smooth;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        justify-content: flex-start;
        align-items: center;

        -ms-overflow-style: none;  /* IE 10+ */
        overflow: -moz-scrollbars-none; /* should hide scroll bar */
        overflow: hidden;

        &::-webkit-scrollbar{
            display: none; /*  might be enough */
            background: transparent;
            visibility: hidden;
            width: 0;
        }

        .slide{
            width: auto;
            flex: 0;

            &:hover{
                //background-color: #ff0000;
            }
        }
    }
}

.error{
    text-align: center;
}

.loading{
    text-align: center;
}
</style>